// eslint-disable-next-line import/no-extraneous-dependencies
import React, { type MouseEvent } from 'react';
import { Footer, FooterDismissLink } from './styled';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable, xcss } from '@atlaskit/primitives';

export interface ChecklistFooterProps {
	dismissTitle: string;
	onDismiss: (e: MouseEvent<HTMLElement>) => void;
	wrapper?: React.ElementType;
}

export default ({ dismissTitle, onDismiss, wrapper }: ChecklistFooterProps) => {
	const FooterWrapper = wrapper ? wrapper : Footer;

	return (
		<FooterWrapper>
			{fg('jira_onboarding_a11y_fixes_for_quickstart') ? (
				<Pressable xcss={buttonStyles} testId="checklist-footer-dismiss-link" onClick={onDismiss}>
					{dismissTitle}
				</Pressable>
			) : (
				<FooterDismissLink data-testid="checklist-footer-dismiss-link" href="#" onClick={onDismiss}>
					{dismissTitle}
				</FooterDismissLink>
			)}
		</FooterWrapper>
	);
};

const buttonStyles = xcss({
	color: 'color.text.discovery',
	font: 'font.body',
	background: 'none',
	':hover': {
		textDecoration: 'none',
	},
});
